(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[238],{

/***/ 8718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]",
      function () {
        return __webpack_require__(8391);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Product; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ../node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(205);
// EXTERNAL MODULE: ./src/contexts/globalProductPageContext.js
var globalProductPageContext = __webpack_require__(2448);
// EXTERNAL MODULE: ./src/hooks/index.js + 36 modules
var hooks = __webpack_require__(4068);
// EXTERNAL MODULE: ./src/snippets/index.js + 131 modules
var snippets = __webpack_require__(1790);
// EXTERNAL MODULE: ./src/snippets/Okendo/OkendoStarRating.jsx
var OkendoStarRating = __webpack_require__(391);
// EXTERNAL MODULE: ./src/snippets/Link/index.js + 1 modules
var Link = __webpack_require__(7227);
;// CONCATENATED MODULE: ./src/snippets/PDP/Breadcrumbs.jsx




function Breadcrumbs(param) {
    var product = param.product;
    var ref = (0,react.useState)("shop-all"), collectionHandle = ref[0], setCollectionHandle = ref[1];
    var ref1 = (0,react.useState)(null), collectionObject = ref1[0], setCollectionObject = ref1[1];
    var fetchCollectionByHandle = (0,dist.useCollectionByHandle)({
        handle: collectionHandle,
        fetchOnMount: false
    }).fetchCollectionByHandle;
    (0,react.useEffect)(function() {
        var handle = "shop-all";
        if (typeof sessionStorage !== "undefined") {
            var storedPreviousCollection = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("PREVIOUS_PATH");
            if (storedPreviousCollection === null || storedPreviousCollection === void 0 ? void 0 : storedPreviousCollection.includes("/collections/")) {
                handle = storedPreviousCollection.replace("/collections/", "");
                setCollectionHandle(handle);
            }
        }
        fetchCollectionByHandle({
            handle: handle
        }).then(function(item) {
            setCollectionObject(item);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "breadcrumbs hidden pb-[30px] text-sm font-light text-primary md:block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex gap-2 [&_li:not(:last-child)]:after:content-['/'] [&_li]:after:ml-2 [&_li]:after:inline-block",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        href: "/",
                        children: "Home"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        href: "/collections/".concat(collectionHandle),
                        children: collectionObject === null || collectionObject === void 0 ? void 0 : collectionObject.title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: product === null || product === void 0 ? void 0 : product.title
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(6471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductColorOptionValue.jsx





function ColorOptionValue(param) {
    var isSelected = param.isSelected, swatch = param.swatch, value = param.value;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "swatch-selector relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-[50%] transition md:hover:border-text ".concat(isSelected ? "border border-text" : ""),
        style: {
            backgroundColor: swatch === null || swatch === void 0 ? void 0 : swatch.color
        },
        children: [
            (swatch === null || swatch === void 0 ? void 0 : (ref = swatch.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                alt: value,
                className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover",
                height: "32",
                src: swatch.image.src,
                width: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-[50%] border-clearBlue transition-[border-width] duration-100 ".concat(isSelected ? "border-[3px]" : "border-[0px]")
            })
        ]
    });
}
function ProductColorOptionValue(param) {
    var inventory = param.inventory, isSelected = param.isSelected, newSelectedOptions = param.newSelectedOptions, product = param.product, setSelectedOptions = param.setSelectedOptions, value = param.value;
    var ref, ref1, ref2, ref3, ref4;
    var settings = (0,dist.useSettings)();
    var swatches = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.swatches;
    var isFromGrouping = (ref2 = product.grouping) === null || ref2 === void 0 ? void 0 : ref2.isTransformed;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
    }, [
        newSelectedOptions,
        product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref3 = inventory.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref4 === void 0 ? void 0 : ref4.availableForSale) || false;
    var swatch = (0,react.useMemo)(function() {
        if (!swatches) return null;
        return swatches.find(function(param) {
            var name = param.name;
            return (name === null || name === void 0 ? void 0 : name.trim().toLowerCase()) === value.toLowerCase();
        }) || null;
    }, [
        swatches,
        value
    ]);
    var url = (0,react.useMemo)(function() {
        if (!isFromGrouping) return null;
        var selectedVariantFromOptions = product.grouping.variants.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
        if (!selectedVariantFromOptions) return null;
        var params = "";
        if (true) {
            var search = window.location.search;
            params = new URLSearchParams(search);
            params.set("variant", selectedVariantFromOptions.legacyResourceId);
        }
        return "/products/".concat(selectedVariantFromOptions.product.handle, "?").concat(params);
    }, [
        isFromGrouping,
        newSelectedOptions
    ]);
    return isFromGrouping ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "product-option-item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
            "aria-label": value,
            href: url,
            onClick: function(e) {
                if (isSelected) e.preventDefault();
            },
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionValue, {
                isSelected: isSelected,
                swatch: swatch,
                value: value
            })
        })
    }) : variantFromOptionValue && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "product-option-item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            "aria-label": value,
            onClick: function() {
                if (isSelected) return;
                setSelectedOptions(newSelectedOptions);
            },
            className: "relative\n            ".concat(isSelected && !optionValueIsAvailable ? "[&>div]:!border-error" : "", "\n            ").concat(!optionValueIsAvailable ? 'after:absolute after:left-0 after:right-0 after:top-1/2 after:h-[2px] after:-translate-y-[1px] after:-rotate-45 after:scale-90 after:bg-clearBlue after:content-[""]' : "", "\n          "),
            type: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionValue, {
                isSelected: isSelected,
                swatch: swatch,
                value: value
            })
        })
    });
}
ProductColorOptionValue.displayName = "ProductColorOptionValue";
ColorOptionValue.displayName = "ColorOptionValue";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptionValue.jsx



function ProductOptionValue(param) {
    var inventory = param.inventory, isSelected = param.isSelected, newSelectedOptions = param.newSelectedOptions, product = param.product, setSelectedOptions = param.setSelectedOptions, value = param.value;
    var ref, ref1;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
    }, [
        newSelectedOptions,
        product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref1 === void 0 ? void 0 : ref1.availableForSale) || false;
    var disabled = !variantFromOptionValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "product-option-item whitespace-nowrap",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            "aria-label": value,
            className: "relative mb-1 inline-block min-w-[3.5rem] overflow-hidden border px-[20px] py-[10px] text-[0.7rem] text-text transition hover:border-text hover:bg-white md:mb-0 md:text-base md:hover:border-text\n        ".concat(optionValueIsAvailable ? "border-[#797D86] bg-[#E6F0F8]" : "opacity-50", "\n        ").concat(isSelected ? "cursor-pointer border-black bg-white shadow-[inset_0_0_0_1px_#000000]" : ""),
            disabled: disabled,
            onClick: function() {
                if (isSelected) return;
                setSelectedOptions(newSelectedOptions);
            },
            type: "button",
            children: [
                !optionValueIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 top-[50%] h-[1px] w-[calc(100%+20px)] -rotate-[18deg] border-t border-t-text bg-red-200 opacity-30"
                }),
                value
            ]
        })
    });
}
ProductOptionValue.displayName = "ProductOptionValue";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/ProductOptions.jsx









function ProductOptions(param) {
    var product = param.product, selectedOptions = param.selectedOptions, selectedVariant = param.selectedVariant, setSelectedOptions = param.setSelectedOptions;
    var ref, ref1, ref2, ref3;
    var variantGroups = product.variantGroups;
    var inventory = (0,dist.useProductInventoryByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle,
        withInventory: false
    }).inventory;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
        });
    }, [
        selectedOptions,
        product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref1 = inventory.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref2 === void 0 ? void 0 : ref2.availableForSale) || false;
    // const disabled = !variantFromOptionValue;
    var ref4 = (0,react.useState)(false), displayOos = ref4[0], setDisplayOos = ref4[1];
    (0,react.useEffect)(function() {
        if (!inventory) return;
        setDisplayOos(!optionValueIsAvailable);
    }, [
        inventory,
        optionValueIsAvailable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            inventory && product && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-options flex flex-col text-primary",
                children: (ref3 = product.options) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                    var id = param.id, name = param.name, values = param.values;
                    var ref;
                    var productOrGroupingValues = ((ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.optionsMap[name] : values;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-option-group border-b border-b-[#DDE2E7] py-3 first:border-t first:border-t-[#DDE2E7] md:py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-selected-option mb-2 flex items-center justify-between gap-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2 md:mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "product-selected-option__name text-[11px] font-normal uppercase leading-6 md:text-base",
                                            children: name === "Size" ? "Select a Size" : "".concat(name, ":")
                                        }),
                                        name !== "Size" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "product-selected-option__value text-[11px] font-normal uppercase md:text-base",
                                            children: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "overflow-x-auto md:overflow-x-visible",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "product-option-list flex gap-2 md:flex-wrap",
                                    children: productOrGroupingValues === null || productOrGroupingValues === void 0 ? void 0 : productOrGroupingValues.map(function(value) {
                                        var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]) === value;
                                        var newSelectedOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), (0,_define_property/* default */.Z)({}, name, value));
                                        var variantIsInGroup = variantGroups.length > 0 && variantGroups.some(function(group) {
                                            return group.variants.some(function(variant) {
                                                var colorOption = variant.selectedOptions.find(function(option) {
                                                    return option.name === "Color";
                                                });
                                                return colorOption.value === value;
                                            });
                                        });
                                        if (variantIsInGroup) return null;
                                        return name === "Color" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorOptionValue, {
                                            inventory: inventory,
                                            isSelected: isSelected,
                                            newSelectedOptions: newSelectedOptions,
                                            product: product,
                                            setSelectedOptions: setSelectedOptions,
                                            value: value
                                        }, value) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValue, {
                                            inventory: inventory,
                                            isSelected: isSelected,
                                            newSelectedOptions: newSelectedOptions,
                                            product: product,
                                            setSelectedOptions: setSelectedOptions,
                                            value: value
                                        }, value);
                                    })
                                })
                            }),
                            variantGroups.length > 0 && name === "Color" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-option-variant-group flex flex-col gap-2",
                                children: variantGroups.map(function(group) {
                                    var metaobject = group.metaobject;
                                    var title = metaobject.title, calloutText = metaobject.callout_text;
                                    var groupValues = group.variants.map(function(variant) {
                                        var colorOption = variant.selectedOptions.find(function(option) {
                                            return option.name === "Color";
                                        });
                                        return colorOption.value;
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-2 flex items-center justify-between gap-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-2 md:mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-[11px] font-normal uppercase leading-6 md:text-base",
                                                            children: title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[11px] italic text-[--shadow-gray] md:text-base",
                                                            children: calloutText
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "flex flex-wrap gap-2",
                                                children: groupValues === null || groupValues === void 0 ? void 0 : groupValues.map(function(value) {
                                                    var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]) === value;
                                                    var newSelectedOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), (0,_define_property/* default */.Z)({}, name, value));
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorOptionValue, {
                                                        inventory: inventory,
                                                        isSelected: isSelected,
                                                        newSelectedOptions: newSelectedOptions,
                                                        product: product,
                                                        setSelectedOptions: setSelectedOptions,
                                                        value: value
                                                    }, value);
                                                })
                                            })
                                        ]
                                    }, group.group);
                                })
                            })
                        ]
                    }, id);
                })
            }),
            displayOos && inventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-options--oos relative mt-4 border border-error p-[10px] text-center text-error before:absolute before:inset-0 before:bg-error before:opacity-[0.15]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative",
                    children: "This item is currently out of stock"
                })
            })
        ]
    });
}
ProductOptions.displayName = "ProductOptions";

;// CONCATENATED MODULE: ./src/templates/product/ProductOptions/index.js


// EXTERNAL MODULE: ./src/snippets/RechargeSubscriptionWidget/RechargeSubscriptionWidget.jsx + 5 modules
var RechargeSubscriptionWidget = __webpack_require__(6426);
;// CONCATENATED MODULE: ./src/templates/product/ProductDetails.jsx





function ProductDetails(param) {
    var product = param.product, productDetailAccordionsSection = param.productDetailAccordionsSection, selectedOptions = param.selectedOptions, selectedVariant = param.selectedVariant, setSelectedOptions = param.setSelectedOptions, scrollReference = param.scrollReference;
    var ref;
    var ref1 = (0,globalProductPageContext/* useGlobalProductPageContext */.j)(), purchaseType = ref1.purchaseType, selectedSellingPlan = ref1.selectedSellingPlan, productSubscriptionWidget = ref1.productSubscriptionWidget;
    var hideOptions = ((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 && product.variants[0].title === "Default Title";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-details flex flex-col gap-3 md:gap-5 md:pl-4 lg:pl-10 xl:pl-16",
        children: [
            !hideOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                product: product,
                selectedOptions: selectedOptions,
                selectedVariant: selectedVariant,
                setSelectedOptions: setSelectedOptions
            }),
            productDetailAccordionsSection || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    productSubscriptionWidget && /*#__PURE__*/ (0,jsx_runtime.jsx)(RechargeSubscriptionWidget/* RechargeSubscriptionWidget */.N, {
                        product: product,
                        widgetContent: productSubscriptionWidget
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AddToCart */.o4, {
                        isPdp: true,
                        selectedVariant: selectedVariant,
                        product: product,
                        purchaseType: purchaseType,
                        selectedSellingPlan: selectedSellingPlan
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: scrollReference
                    })
                ]
            })
        ]
    });
}
ProductDetails.displayName = "ProductDetails";

;// CONCATENATED MODULE: ./src/templates/product/ProductHeader.jsx








function ProductHeader(param) {
    var product = param.product, selectedVariant = param.selectedVariant, purchaseType = param.purchaseType, selectedSellingPlan = param.selectedSellingPlan;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,hooks/* useVariantPrices */.be)({
        variant: selectedVariant,
        purchaseType: purchaseType,
        isPdp: true
    }), price = ref7.price, compareAtPrice = ref7.compareAtPrice;
    var settings = (0,dist.useSettings)();
    var enabledStarRating = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.reviews).enabledStarRating;
    var ref8 = (0,react.useState)(false), hasReviews = ref8[0], setHasReviews = ref8[1];
    var ref9 = (0,globalProductPageContext/* useGlobalProductPageContext */.j)(), productTestResults = ref9.productTestResults, productByline = ref9.productByline;
    (0,react.useEffect)(function() {
        var metaFields = product === null || product === void 0 ? void 0 : product.metafields;
        metaFields === null || metaFields === void 0 ? void 0 : metaFields.forEach(function(metaField) {
            if (metaField.key === "ProductReviewsWidgetSnippet") {
                setHasReviews(true);
            }
        });
    }, [
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-header text-primary md:pl-4 lg:pl-10 xl:pl-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-header__eyebrow mb-[0.6rem] flex items-center gap-x-2 md:mb-4 md:flex-col md:items-start md:gap-x-0 md:gap-y-2 lg:flex-row lg:flex-nowrap lg:items-center lg:gap-x-2 lg:gap-y-0",
                children: [
                    enabledStarRating && hasReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "product-header__ratings inline-flex items-center gap-x-1 whitespace-nowrap",
                        "aria-label": "Scroll to product reviews",
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OkendoStarRating/* OkendoStarRating */.m, {
                            className: "[&_span]:text-[14px] [&_span]:font-light [&_span]:md:text-[20px]",
                            productId: product === null || product === void 0 ? void 0 : product.legacyResourceId
                        })
                    }),
                    productTestResults && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-header__test-results flex items-center justify-start whitespace-nowrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-2 select-none text-center text-sm font-light opacity-10 md:hidden md:text-xl lg:inline-block",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                href: productTestResults.url,
                                className: "text-sm font-light leading-normal underline hover:underline md:text-xl lg:no-underline",
                                children: productTestResults.text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                element: "h1",
                variant: "h3",
                className: "product-header__title -mt-[5px] mb-[3.2px] text-[22px] md:mb-6 md:mt-0",
                children: product.title
            }),
            productByline && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-header__byline tracking-wide mb-[0.2rem] text-sm font-light uppercase md:mb-6",
                children: productByline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-header__price-container -mt-[5px] flex min-h-[1.5rem] items-center gap-2 text-[20px] md:mt-2",
                children: [
                    compareAtPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-header__compare-price text-lg text-mediumGray line-through md:text-xl",
                        children: compareAtPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-header__price text-xl md:mt-0",
                        children: purchaseType === "subscription" && (selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : selectedSellingPlan.priceAdjustments) ? new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref1 = selectedSellingPlan.priceAdjustments) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.currencyCode
                        }).format(selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref4 = selectedSellingPlan.priceAdjustments) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.price) === null || ref6 === void 0 ? void 0 : ref6.amount) : price
                    })
                ]
            })
        ]
    });
}
ProductHeader.displayName = "ProductHeader";

;// CONCATENATED MODULE: ./src/templates/product/useSelectedVariant.js



function useSelectedVariant(product) {
    var ref, ref1, ref2, ref3;
    var query = (0,next_router.useRouter)().query;
    var productPageReady = !!product && product.handle === query.handle;
    var hasOneVariant = ((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1;
    var isNonGroupedProductWithMultiColors = !(product === null || product === void 0 ? void 0 : (ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : ref1.isTransformed) && (product === null || product === void 0 ? void 0 : (ref2 = product.optionsMap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Color) === null || ref3 === void 0 ? void 0 : ref3.length) > 1;
    var ref4 = (0,react.useState)(productPageReady && hasOneVariant ? product.variants[0] : null), selectedVariant = ref4[0], setSelectedVariant = ref4[1];
    var ref5 = (0,react.useState)(productPageReady && hasOneVariant ? product.variants[0].selectedOptionsMap : null), selectedOptions = ref5[0], setSelectedOptions = ref5[1];
    var ref6 = (0,react.useState)(isNonGroupedProductWithMultiColors || !productPageReady ? null : product === null || product === void 0 ? void 0 : product.media), selectedMedia = ref6[0], setSelectedMedia = ref6[1];
    // set initial selected options on mount unless has one variant
    var setInitialSelectedOptionsOnProductMount = (0,react.useCallback)(function() {
        var ref;
        if (!productPageReady) {
            setSelectedOptions(null);
            return;
        }
        if (((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 && selectedOptions) {
            // Fix PACK bug when visiting a product page from a product page, and only 1 variant exists
            setSelectedVariant(product.variants[0]);
            return;
        }
        var params = new URLSearchParams(window.location.search);
        var queriedVariantId = params.get("variant");
        var queriedVariant = null;
        if (queriedVariantId) {
            queriedVariant = product.variants.find(function(param) {
                var legacyResourceId = param.legacyResourceId;
                return legacyResourceId === queriedVariantId;
            });
        }
        if (queriedVariant) {
            setSelectedOptions(queriedVariant.selectedOptionsMap);
        } else {
            var firstAvailableVariant = product.variants.find(function(param) {
                var availableForSale = param.availableForSale;
                return availableForSale;
            });
            if (firstAvailableVariant) {
                setSelectedOptions(firstAvailableVariant.selectedOptionsMap);
            } else {
                var ref1;
                // If no variants are available, fall back to the first variant
                setSelectedOptions(((ref1 = product.variants[0]) === null || ref1 === void 0 ? void 0 : ref1.selectedOptionsMap) || null);
            }
        }
    }, [
        query.handle,
        product === null || product === void 0 ? void 0 : product.id
    ]);
    // set selected variant from selected options unless has one variant
    var setSelectedVariantFromSelectedOptions = (0,react.useCallback)(function() {
        var ref;
        if (!productPageReady || !selectedOptions) {
            setSelectedVariant(null);
            return;
        }
        if (((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 && selectedVariant) return;
        var selectedVariantFromOptions = product.variants.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
        });
        setSelectedVariant(selectedVariantFromOptions || null);
    }, [
        query.handle,
        product === null || product === void 0 ? void 0 : product.id,
        selectedOptions,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    // set variant url param on selected variant change unless has one variant
    var setVariantUrlParamOnSelectedVariantChange = (0,react.useCallback)(function() {
        var ref;
        if (!productPageReady) return;
        if (((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 || !selectedVariant) return;
        var _location = window.location, origin = _location.origin, search = _location.search;
        var params = new URLSearchParams(search);
        params.set("variant", selectedVariant.legacyResourceId);
        var updatedUrl = "".concat(origin, "/products/").concat(selectedVariant.product.handle, "?").concat(params);
        window.history.replaceState(window.history.state, "", updatedUrl);
    }, [
        query.handle,
        product === null || product === void 0 ? void 0 : product.id,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    // set selected media on selected variant change
    var setSelectedMediaOnSelectedVariantChange = (0,react.useCallback)(function() {
        var getFilteredMedia = function getFilteredMedia(media) {
            if (!variants.includes(media.alt.toLowerCase())) return media;
            if (media.alt.toLowerCase() === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.title.toLowerCase())) return media;
            return null;
        };
        var ref;
        if (!productPageReady) {
            setSelectedMedia(null);
            return;
        }
        var options = Object.keys(product.optionsMap || {});
        var variants = options.map(function(option) {
            return product.optionsMap[option];
        }).flat().map(function(option) {
            return option.toLowerCase();
        });
        var newMedia = (ref = product.media) === null || ref === void 0 ? void 0 : ref.map(getFilteredMedia).filter(function(media) {
            return media;
        });
        setSelectedMedia(newMedia);
    // I'M LEAVING BELOW CODE IN CASE WE NEED TO REVERT BACK TO IT
    // OR IF WE NEED TO ADD MULTIPLE FILTER SUPPORT IN THE FUTURE
    // // filter media by color via possible alt tag if product is not grouped and has multiple colors
    // if (
    //   (product.optionsMap.Color || product.optionsMap.Size) &&
    //   selectedVariant
    // ) {
    //   // Set up our list of available color options on the primary product
    //   const colorOptions = product.optionsMap?.Color?.map((color) =>
    //     color.toLowerCase()
    //   );
    //   // Set up our list of available size options on the primary product
    //   const sizeOptions = product.optionsMap?.Size?.map((size) =>
    //     size.toLowerCase()
    //   );
    //   // Based on the current selected variant, what color and size are we viewing?
    //   const selectedColor =
    //     selectedVariant.selectedOptionsMap.Color?.toLowerCase();
    //   const selectedSize =
    //     selectedVariant.selectedOptionsMap.Size?.toLowerCase();
    //   // Next we'll filter on the alt text to see if it matches a color or size value
    //   let filteredMedia = [];
    //   // If both Sizes & Colors are available on this product filter on both.
    //   if (
    //     product.optionsMap?.Color?.length > 0 &&
    //     product.optionsMap?.Size?.length > 0
    //   ) {
    //     filteredMedia = product.media.filter((item) => {
    //       const alt = item.alt?.trim().toLowerCase();
    //       // Includes all images containing "color / size" OR contains no "/" in it.
    //       return (
    //         alt === `${selectedColor} / ${selectedSize}` || !alt.includes('/')
    //       );
    //     });
    //   }
    //   // If only color options are available, then filter those.
    //   else if (product.optionsMap?.Color?.length > 0) {
    //     filteredMedia = product.media.filter((item) => {
    //       const alt = item.alt?.trim().toLowerCase();
    //       return alt === selectedColor || !colorOptions.includes(alt);
    //     });
    //   }
    //   // If only size options are available, then filter those.
    //   else if (product.optionsMap?.Size?.length > 0) {
    //     filteredMedia = product.media.filter((item) => {
    //       const alt = item.alt?.trim().toLowerCase();
    //       return alt === selectedSize || !sizeOptions.includes(alt);
    //     });
    //   }
    //   console.log('filteredMedia', filteredMedia);
    //   setSelectedMedia(filteredMedia);
    // } else {
    //   console.log('filteredMedia', product.media);
    //   setSelectedMedia(product.media);
    // }
    }, [
        query.handle,
        product === null || product === void 0 ? void 0 : product.id,
        selectedMedia,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    (0,react.useEffect)(function() {
        setInitialSelectedOptionsOnProductMount();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    (0,react.useEffect)(function() {
        setSelectedVariantFromSelectedOptions();
    }, [
        selectedOptions
    ]);
    (0,react.useEffect)(function() {
        setVariantUrlParamOnSelectedVariantChange();
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    (0,react.useEffect)(function() {
        setSelectedMediaOnSelectedVariantChange();
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    return {
        selectedOptions: selectedOptions,
        selectedVariant: selectedVariant,
        setSelectedOptions: setSelectedOptions,
        selectedMedia: selectedMedia
    };
}

;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/ProductImage.jsx


function ProductImage(param) {
    var media = param.media, priority = param.priority;
    var image = media.image, product = media.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative aspect-square bg-[#E6F0F8]",
        children: (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
            alt: product.title,
            fill: true,
            priority: priority,
            className: "!object-contain mix-blend-multiply",
            sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
            src: image.src,
            // IMPORTANT: for naturally large, high resolution images from Shopify,
            // reduce quality back to the default 75 for better page performance
            quality: 90
        })
    });
}
ProductImage.displayName = "ProductImage";

;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/ProductVideo.jsx



function ProductVideo(param) {
    var media = param.media, controls = param.controls, cover = param.cover;
    var ref;
    var videoRef = (0,react.useRef)(null);
    var ref1 = (0,react_intersection_observer/* useInView */.YD)({
        threshold: 0
    }), ref2 = ref1.ref, inView = ref1.inView;
    var sources = media.sources, preview = media.preview;
    var videoSources = sources === null || sources === void 0 ? void 0 : sources.filter(function(param) {
        var mimeType = param.mimeType;
        return mimeType === "video/mp4";
    });
    (0,react.useEffect)(function() {
        if (inView) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref2,
        className: "flex aspect-square items-center justify-center bg-[#E6F0F8]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            ref: videoRef,
            muted: true,
            playsInline: true,
            loop: true,
            controls: controls || false,
            poster: preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.src,
            className: "h-full w-full ".concat(!!cover && "object-cover"),
            children: inView && (videoSources === null || videoSources === void 0 ? void 0 : videoSources.length) ? videoSources.map(function(source) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: source.url,
                    type: source.mimeType
                }, source.url);
            }) : null
        })
    });
}
ProductVideo.displayName = "ProductVideo";

// EXTERNAL MODULE: ../node_modules/swiper/modules/index.mjs + 28 modules
var modules = __webpack_require__(3365);
// EXTERNAL MODULE: ../node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(5509);
;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/ProductMediaSlider.jsx





function ProductMediaSlider(param) {
    var memoizedProductMedia = param.memoizedProductMedia, onSwiper = param.onSwiper, onSlideChange = param.onSlideChange, _navigation = param.navigation, navigation = _navigation === void 0 ? false : _navigation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        modules: [
            modules/* A11y */.s5,
            modules/* Pagination */.tl
        ],
        slidesPerView: 1,
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        lazy: {
            loadPrevNext: true
        },
        navigation: navigation,
        onSwiper: onSwiper,
        onSlideChange: function(s) {
            return onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(s.realIndex);
        },
        children: memoizedProductMedia === null || memoizedProductMedia === void 0 ? void 0 : memoizedProductMedia.map(function(media, index) {
            var mediaContentType = media.mediaContentType, image = media.image, product = media.product, sources = media.sources, preview = media.preview;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: mediaContentType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo, {
                        media: media,
                        controls: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        media: media,
                        priority: index === 0
                    })
                })
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/ProductMediaCalloutGrid.jsx


function ProductMediaCalloutGrid() {
    var productAdditionalDetails = (0,globalProductPageContext/* useGlobalProductPageContext */.j)().productAdditionalDetails;
    var sectionData = productAdditionalDetails === null || productAdditionalDetails === void 0 ? void 0 : productAdditionalDetails.props.children.props.children.props.cms;
    var calloutItems = (sectionData === null || sectionData === void 0 ? void 0 : sectionData.productCallouts) || [];
    if (!calloutItems.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-4 flex flex-col space-y-4 md:my-0 lg:flex-row lg:space-y-0",
        children: calloutItems.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center space-x-4 px-2 text-center lg:flex-col lg:space-x-0 lg:space-y-4",
                children: [
                    item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "h-9 w-9",
                        alt: item.icon.altText,
                        src: item.icon.url,
                        width: item.icon.width,
                        height: item.icon.height
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-left lg:text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "inline text-xs font-normal lg:block xl:text-lg",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-1 inline text-xs lg:ml-0 lg:block xl:text-base",
                                children: item.content
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ./src/contexts/index.js + 1 modules
var contexts = __webpack_require__(8249);
;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/useOpenMediaModal.jsx






function useOpenMediaModal() {
    var ref = (0,contexts/* useGlobalContext */.b)(), openModal = ref.actions.openModal;
    var modalRef = (0,react.useRef)(null);
    var handleModal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var imageSrc, videoSources, openInFullscreen, altText, videoSource, video;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageSrc = param.imageSrc, videoSources = param.videoSources, openInFullscreen = param.openInFullscreen, altText = param.altText;
                        videoSource = null;
                        if (videoSources === null || videoSources === void 0 ? void 0 : videoSources.length) {
                            videoSource = videoSources.find(function(source) {
                                return source.format === "mp4";
                            });
                        }
                        // example modal
                        return [
                            4,
                            openModal(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: modalRef,
                                children: [
                                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "modal-image-wrapper relative flex aspect-video h-[40rem] w-full max-w-[1200px] items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                alt: altText || "Image Preview",
                                                fill: true,
                                                sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
                                                className: "!object-contain mix-blend-multiply",
                                                src: imageSrc
                                            })
                                        })
                                    }),
                                    videoSource && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "modal-video-wrapper w-[1920px] max-w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                            autoPlay: true,
                                            controls: true,
                                            className: "h-full w-full object-cover",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                src: videoSource === null || videoSource === void 0 ? void 0 : videoSource.url,
                                                type: "video/mp4"
                                            })
                                        })
                                    })
                                ]
                            }))
                        ];
                    case 1:
                        _state.sent();
                        if (videoSource && openInFullscreen) {
                            video = modalRef.current.querySelector("video");
                            if (!video) {
                                console.error("Video element not found in modal");
                                return [
                                    2
                                ];
                            }
                            if (video.requestFullscreen) {
                                video.requestFullscreen();
                            } else if (video.mozRequestFullScreen) {
                                video.mozRequestFullScreen();
                            } else if (video.webkitRequestFullscreen) {
                                video.webkitRequestFullscreen();
                            } else if (video.msRequestFullscreen) {
                                video.msRequestFullscreen();
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModal(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleModal: handleModal
    };
}

;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/ProductMediaGallery.jsx








function Thumb(param) {
    var media = param.media, index = param.index, activeIndex = param.activeIndex, size = param.size, onSelect = param.onSelect;
    var isActive = index === activeIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": "Select media ".concat(index + 1),
        onClick: function() {
            return onSelect(index);
        },
        className: "shrink-0 border-2 ".concat(isActive ? "border-primary" : "hover:border-gray-300 border-transparent"),
        type: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(size, " aspect-square overflow-hidden"),
            children: media.mediaContentType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo, {
                media: media,
                controls: false,
                cover: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                media: media,
                fill: true,
                className: "object-cover"
            })
        })
    });
}
function ProductMediaGallery(param) {
    var _selectedMedia = param.selectedMedia, selectedMedia = _selectedMedia === void 0 ? [] : _selectedMedia, selectedVariant = param.selectedVariant;
    var ref, ref1;
    var handleModal = useOpenMediaModal().handleModal;
    var ref2 = (0,react.useState)(0), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var ref3 = (0,react.useState)(null), swiper = ref3[0], setSwiper = ref3[1];
    var ref4 = (0,react.useState)(false), thumbOverflow = ref4[0], setThumbOverflow = ref4[1];
    var thumbRailRef = (0,react.useRef)(null);
    var active = selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia[activeIndex];
    /* reset thumb when colour changes */ (0,react.useEffect)(function() {
        return setActiveIndex(0);
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.selectedOptionsMap) === null || ref === void 0 ? void 0 : ref.Color
    ]);
    /* rail overflow set */ (0,react.useEffect)(function() {
        var el = thumbRailRef.current;
        if (el) setThumbOverflow(el.scrollHeight > el.clientHeight);
        jumpTo(0);
    }, [
        selectedMedia
    ]);
    var openModal = (0,react.useCallback)(function() {
        if (!active || active.mediaContentType === "VIDEO") return;
        handleModal({
            imageSrc: active.image.src,
            altText: active.image.altText
        });
    }, [
        active,
        handleModal
    ]);
    var scrollThumbs = function() {
        var ref;
        return (ref = thumbRailRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            top: 300,
            behavior: "smooth"
        });
    };
    var jumpTo = function(i) {
        setActiveIndex(i);
        if (swiper) {
            var ref;
            ((ref = swiper.params) === null || ref === void 0 ? void 0 : ref.loop) ? swiper.slideToLoop(i, 0) : swiper.slideTo(i, 0);
        }
    };
    var handleSlideChange = function(i) {
        if ((selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.length) > 1) {
            setActiveIndex(i);
        }
    };
    return !!active && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 gap-6 xl:grid-cols-[96px_1fr] xl:gap-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "order-0 relative hidden xl:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: thumbRailRef,
                        className: "max-h-[calc(100vh-200px)] overflow-y-auto pr-1",
                        children: selectedMedia.map(function(m, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                media: m,
                                index: i,
                                activeIndex: activeIndex,
                                size: "h-20 w-20",
                                onSelect: jumpTo
                            }, m.id);
                        })
                    }),
                    thumbOverflow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: scrollThumbs,
                        "aria-label": "Scroll thumbnails down",
                        className: "absolute bottom-0 left-1/2 -translate-x-1/2 p-2",
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                            src: "/svgs/arrow-down.svg#arrow-down",
                            className: "hover:text-gray-800 h-6 w-6 text-mediumGray",
                            viewBox: "0 0 24 24"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative order-1 bg-[#E6F0F8]",
                children: [
                    active && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: openModal,
                        "aria-label": "Open product image in modal",
                        className: "hidden w-full xl:block",
                        type: "button",
                        children: active.mediaContentType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo, {
                            media: active,
                            controls: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                            media: active,
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "xl:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaSlider, {
                                        memoizedProductMedia: selectedMedia,
                                        onSlideChange: handleSlideChange,
                                        onSwiper: setSwiper
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
                                        },
                                        "aria-label": "Previous image",
                                        className: "absolute left-4 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow",
                                        type: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            src: "/svgs/arrow-left.svg#arrow-left",
                                            className: "hover:text-gray-800 h-4 w-4 text-mediumGray",
                                            viewBox: "0 0 24 24"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
                                        },
                                        "aria-label": "Next image",
                                        className: "absolute right-4 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow",
                                        type: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            src: "/svgs/arrow-right.svg#arrow-right",
                                            className: "hover:text-gray-800 h-4 w-4 text-mediumGray",
                                            viewBox: "0 0 24 24"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 flex gap-3 overflow-x-auto whitespace-nowrap scrollbar-hide",
                                children: selectedMedia.map(function(m, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                        media: m,
                                        index: i,
                                        activeIndex: activeIndex,
                                        size: "h-16 w-16",
                                        onSelect: jumpTo
                                    }, m.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-none absolute right-4 top-4 z-[1]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Badges */.a9, {
                            tags: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.tags
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "order-2 xl:col-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaCalloutGrid, {})
            })
        ]
    });
}
ProductMediaGallery.displayName = "ProductMediaGallery";

;// CONCATENATED MODULE: ./src/templates/product/ProductMediaGallery/index.js


;// CONCATENATED MODULE: ./src/templates/product/product.jsx
/* eslint-disable react/jsx-no-constructed-context-values */ 














function ProductTemplate(param) {
    var renderSections = param.renderSections, product = param.product;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, /* Image */ ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var settings = (0,dist.useSettings)();
    var sections = renderSections();
    var sendViewProductEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewProductEvent;
    var ref14 = (0,contexts/* useGlobalContext */.b)(), testVariant = ref14.state.testVariant;
    var ref15 = useSelectedVariant(product), selectedVariant = ref15.selectedVariant, setSelectedOptions = ref15.setSelectedOptions, selectedOptions = ref15.selectedOptions, selectedMedia = ref15.selectedMedia;
    var productSubscriptionWidget = (0,hooks/* useSubscriptionWidget */.FG)(product).productSubscriptionWidget;
    var ref16 = (0,react.useState)(null), productTestResults = ref16[0], setProductTestResults = ref16[1];
    var ref17 = (0,react.useState)(null), recommendedProducts = ref17[0], setRecommendedProducts = ref17[1];
    var ref18 = (0,react.useState)(null), recommendedFilterFrequency = ref18[0], setRecommendedFilterFrequency = ref18[1];
    var ref19 = (0,react.useState)(null), selectedSellingPlan = ref19[0], setSelectedSellingPlan = ref19[1];
    var ref20 = (0,react.useState)(null), productByline = ref20[0], setProductByline = ref20[1];
    var ref21 = (0,react.useState)(product.sellingPlanGroupCount > 0 ? "subscription" : "one-time"), purchaseType = ref21[0], setPurchaseType = ref21[1];
    var enabledStarRating = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.reviews).enabledStarRating;
    // pass the scroll reference to the product details section
    var ref22 = (0,react_intersection_observer/* useInView */.YD)({
        threshold: 0,
        initialInView: true
    }), scrollReference = ref22.ref, entry = ref22.entry;
    // separate the product detail accordions from the below the fold sections
    var unrenderSections = [
        "product-detail-accordions",
        "product-additional-details", 
    ];
    var ref23 = (0,react.useMemo)(function() {
        if (!sections) return {};
        return {
            productAdditionalDetails: sections.find(function(param) {
                var props = param.props;
                return (props === null || props === void 0 ? void 0 : props["data-comp"]) === "product-additional-details";
            }),
            productDetailAccordionsSection: sections.find(function(param) {
                var props = param.props;
                return (props === null || props === void 0 ? void 0 : props["data-comp"]) === "product-detail-accordions" && !(props === null || props === void 0 ? void 0 : props.hidden);
            }),
            belowTheFoldSections: sections.filter(function(param) {
                var props = param.props;
                return !unrenderSections.includes(props === null || props === void 0 ? void 0 : props["data-comp"]);
            })
        };
    }, [
        sections
    ]), productAdditionalDetails = ref23.productAdditionalDetails, productDetailAccordionsSection = ref23.productDetailAccordionsSection, belowTheFoldSections = ref23.belowTheFoldSections;
    (0,react.useEffect)(function() {
        sendViewProductEvent({
            product: product,
            selectedVariant: selectedVariant
        });
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.handle,
        sendViewProductEvent
    ]);
    // set class for sticky header
    var stickyPromobar = (settings === null || settings === void 0 ? void 0 : (ref2 = settings.header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.promobar) === null || ref3 === void 0 ? void 0 : ref3.enabled) && !(settings === null || settings === void 0 ? void 0 : (ref4 = settings.header) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.promobar) === null || ref5 === void 0 ? void 0 : ref5.autohide);
    var stickyTopClass = stickyPromobar ? "md:top-[calc(var(--header-height)+var(--promobar-height)+2.5rem)] xl:top-[calc(var(--header-height)+var(--promobar-height)+3rem)]" : "md:top-[calc(var(--header-height)+2.5rem)] xl:top-[calc(var(--header-height)+3rem)]";
    // set global product data
    var globalProductData = {
        selectedSellingPlan: selectedSellingPlan,
        setSelectedSellingPlan: setSelectedSellingPlan,
        purchaseType: purchaseType,
        setPurchaseType: setPurchaseType,
        recommendedFilterFrequency: recommendedFilterFrequency,
        setRecommendedFilterFrequency: setRecommendedFilterFrequency,
        selectedVariant: selectedVariant,
        recommendedProducts: recommendedProducts,
        setRecommendedProducts: setRecommendedProducts,
        scrollReference: scrollReference,
        productSubscriptionWidget: productSubscriptionWidget,
        productTestResults: productTestResults,
        setProductTestResults: setProductTestResults,
        productByline: productByline,
        setProductByline: setProductByline,
        productAdditionalDetails: productAdditionalDetails
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(globalProductPageContext/* GlobalProductPageContext.Provider */.n.Provider, {
        value: globalProductData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product__sticky-cta fixed left-0 top-0 z-20 w-full bg-white py-[16px] md:py-[5px] ".concat(!entry || (entry === null || entry === void 0 ? void 0 : (ref6 = entry.boundingClientRect) === null || ref6 === void 0 ? void 0 : ref6.top) > 0 ? "hidden" : "block"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-contained container mx-auto max-w-[var(--content-max-width)] px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-center justify-between sm:flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden items-center sm:flex",
                                children: [
                                    ((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref7 = selectedVariant.image) === null || ref7 === void 0 ? void 0 : ref7.src) || (product === null || product === void 0 ? void 0 : (ref8 = product.featuredImage) === null || ref8 === void 0 ? void 0 : ref8.src)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative aspect-square w-[60px] flex-[0_0_60px] bg-background max-sm:hidden",
                                        children: [
                                            (product === null || product === void 0 ? void 0 : (ref9 = product.featuredImage) === null || ref9 === void 0 ? void 0 : ref9.src) && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref10 = selectedVariant.image) === null || ref10 === void 0 ? void 0 : ref10.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                alt: product === null || product === void 0 ? void 0 : product.title,
                                                className: "absolute h-full w-full object-contain !mix-blend-multiply",
                                                width: "60px",
                                                height: "60px",
                                                src: product === null || product === void 0 ? void 0 : (ref11 = product.featuredImage) === null || ref11 === void 0 ? void 0 : ref11.src
                                            }),
                                            (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref12 = selectedVariant.image) === null || ref12 === void 0 ? void 0 : ref12.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                alt: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.title,
                                                className: "absolute h-full w-full object-contain !mix-blend-multiply",
                                                width: "60px",
                                                height: "60px",
                                                src: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref13 = selectedVariant.image) === null || ref13 === void 0 ? void 0 : ref13.src
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "stick-product-details mr-[20px] sm:ml-[40px]",
                                        children: [
                                            (product === null || product === void 0 ? void 0 : product.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "hidden text-[16px] sm:block",
                                                children: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.displayName.split("- Default Title")[0]
                                            }),
                                            enabledStarRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(OkendoStarRating/* OkendoStarRating */.m, {
                                                productId: product === null || product === void 0 ? void 0 : product.legacyResourceId
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AddToCart */.o4, {
                                className: "!mt-0 !px-[32px] !py-[10px] max-sm:mx-auto max-sm:block max-sm:max-w-[262px] max-sm:text-[14px]",
                                addToCartText: "Add to Cart",
                                selectedVariant: selectedVariant,
                                purchaseType: purchaseType,
                                selectedSellingPlan: selectedSellingPlan
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product__top-section md:px-contained mt-3 max-w-[var(--content-max-width)] md:mx-auto md:mt-7 md:pb-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto flex flex-col md:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block px-4 pb-4 md:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader, {
                                    selectedSellingPlan: selectedSellingPlan,
                                    purchaseType: purchaseType,
                                    product: product,
                                    selectedVariant: selectedVariant
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product__media-section order-0 my-0 md:flex-[0_0_50%] xl:flex-[0_0_55%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:sticky ".concat(stickyTopClass),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaGallery, {
                                        selectedMedia: selectedMedia,
                                        selectedVariant: selectedVariant,
                                        product: product
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product__details-section relative z-10 order-1 px-4 md:flex-[0_0_50%] xl:flex-[0_0_45%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-4 md:sticky ".concat(stickyTopClass),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden md:block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader, {
                                                selectedSellingPlan: selectedSellingPlan,
                                                purchaseType: purchaseType,
                                                product: product,
                                                selectedVariant: selectedVariant
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                                            scrollReference: scrollReference,
                                            product: product,
                                            productDetailAccordionsSection: productDetailAccordionsSection,
                                            selectedOptions: selectedOptions,
                                            selectedVariant: selectedVariant,
                                            setSelectedOptions: setSelectedOptions
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product__page-sections",
                children: belowTheFoldSections || null
            })
        ]
    });
}
ProductTemplate.displayName = "ProductTemplate";

;// CONCATENATED MODULE: ./src/templates/product/index.js

/* harmony default export */ var templates_product = (ProductTemplate);

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(3183);
;// CONCATENATED MODULE: ./src/pages/products/[handle].jsx
/* eslint-disable import/no-unresolved */ 









function DraftBadge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        "data-comp": "DraftProductBadge",
        // eslint-disable-next-line react/no-unknown-property
        sx: {
            position: "fixed",
            right: 0,
            top: 175,
            transform: "rotate(-90deg)",
            transformOrigin: "bottom right",
            backgroundColor: "#433d51",
            color: "#FFF",
            px: "20px",
            py: "10px",
            fontSize: "14px",
            letterSpacing: "4px",
            fontWeight: 200
        },
        children: "DRAFT"
    });
}
var __N_SSG = true;
function Product(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var router = (0,next_router.useRouter)();
    var settingProduct = (0,react.useRef)(false);
    var product = props.product;
    var ref = (0,_sliced_to_array/* default */.Z)(dist.store.recoil.useRecoilState(dist.store.state.product), 2), recoilProduct = ref[0], setProduct = ref[1];
    var hasQueryParam = router.asPath.includes("?");
    var nextQueryParamReady = Object.keys(router.query).length > 1;
    var handlesMatch = (product === null || product === void 0 ? void 0 : product.handle) === (recoilProduct === null || recoilProduct === void 0 ? void 0 : recoilProduct.handle);
    (0,react.useEffect)(function() {
        if (!handlesMatch) {
            // load the product onto the recoil state
            settingProduct.current = true;
            setProduct(product);
        } else {
            settingProduct.current = false;
        }
        return function() {
            if (hasQueryParam && !nextQueryParamReady) {
                // if we are processing query params
                return;
            }
            if (!settingProduct.current) {
                // unload the product onto the recoil state
                setProduct(null);
            }
        };
    }, [
        handlesMatch
    ]);
    var productPage = props.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageHead */.yG, {
            page: productPage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(templates_product, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        product: product,
                        renderSections: renderSections
                    })),
                    (product === null || product === void 0 ? void 0 : product.publishedAt) === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DraftBadge, {}) : null
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);